export default "query HomeClubModal{user{homeClub{code}cart{cart{discountPendingTotal}}}}"